import { apiClient } from "../apiClient";

const BASE_URL = "/backend/api/v1/admin/developer-feature-flags";

type ApiEnvelope<T> = {
  body: T;
  error: string | null;
};

export interface DeveloperFeatureFlagSettings {
  superset_analytics?: boolean | null;
  ai_analytics?: boolean | null;
  legacy_analytics?: boolean | null;
  partner_access?: boolean | null;
  fraud_prevention?: boolean | null;
  /** Per-organization opt-in for the vehicle-model catalogue (LISA-555). */
  vehicle_models?: boolean | null;
  // Internal grandfathering cutover, managed/defaulted server-side on enable — never edited
  // from the dashboard. Present here only so reads round-trip it.
  onboarding_deposit_effective_from?: string | null;
}

interface DeveloperFeatureFlagsResponse {
  settings: DeveloperFeatureFlagSettings;
}

export async function getDeveloperFeatureFlags(
  orgId: string
): Promise<DeveloperFeatureFlagSettings> {
  const response = await apiClient.get<
    ApiEnvelope<DeveloperFeatureFlagsResponse>
  >(`${BASE_URL}/organizations/${orgId}`);
  return response.data.body.settings;
}

export async function upsertDeveloperFeatureFlags(
  orgId: string,
  settings: DeveloperFeatureFlagSettings
): Promise<DeveloperFeatureFlagSettings> {
  const response = await apiClient.put<
    ApiEnvelope<DeveloperFeatureFlagsResponse>
  >(`${BASE_URL}/organizations/${orgId}`, { settings });
  return response.data.body.settings;
}
